const BaseApi = "https://job-board-software.logicspice.com/job-board-script/api"


export default BaseApi
